import React, { Component, createRef, forwardRef } from 'react';
import { Form as OriginalForm } from 'antd-mobile';
import { even, perhaps } from '../../utils/common';
class Form extends Component {
    constructor() {
        super(...arguments);
        this.formRef = createRef();
    }
    componentDidUpdate(prevProps) {
        const { values: prevValues } = prevProps;
        const { values: currentValues } = this.props;
        if (prevValues !== currentValues) {
            if (currentValues && Object.keys(currentValues).length > 0) {
                this.formRef.current.setFieldsValue(currentValues);
            }
            else {
                this.formRef.current.resetFields();
            }
        }
    }
    componentDidMount() {
        const { values } = this.props;
        Object.defineProperties(this, Object.keys(this.formRef.current).reduce((out, key) => {
            const property = this.formRef.current[key];
            let getter = () => property;
            if (typeof property === 'function') {
                getter = () => property.bind(this.formRef.current);
            }
            out[key] = { get: getter };
            return out;
        }, {}));
        if (values) {
            this.formRef.current.setFieldsValue(values);
        }
    }
    render() {
        const { values, ...rest } = this.props;
        return React.createElement(OriginalForm, Object.assign({ ref: this.formRef }, rest));
    }
}
export var ItemMode;
(function (ItemMode) {
    ItemMode["default"] = "default";
    ItemMode["picker"] = "picker";
})(ItemMode || (ItemMode = {}));
const buildRules = (props) => {
    const { requiredobj, typeobj, patternobj, lenobj, validator } = props;
    const rules = [];
    if (even(requiredobj, requiredobj?.required)) {
        if (!requiredobj.showMessage) {
            delete requiredobj.message;
        }
        delete requiredobj.showMessage;
        rules.push(requiredobj);
    }
    if (even(typeobj, typeobj?.type)) {
        rules.push(typeobj);
    }
    if (even(patternobj, patternobj?.pattern)) {
        rules.push(patternobj);
    }
    if (even(lenobj, perhaps(lenobj?.max, lenobj?.min))) {
        rules.push(lenobj);
    }
    if (even(validator, typeof validator === 'function')) {
        rules.push({
            validator: (_, value) => validator(value),
        });
    }
    return rules;
};
const Item = (props) => {
    const { name } = props;
    const rules = buildRules(props);
    const namePath = typeof name === 'string' && name.indexOf('.') > 0 ? name.split('.') : name;
    const { children, onClick: originalOnClick, mode = 'default', ...other } = props;
    let node = children;
    if (even(Array.isArray(children), children.length === 1)) {
        node = children[0];
    }
    const onClick = mode === ItemMode.picker
        ? (e, datePickerRef) => {
            datePickerRef?.current?.open();
            originalOnClick?.();
        }
        : originalOnClick;
    return (React.createElement(OriginalForm.Item, Object.assign({}, other, { name: namePath, rules: rules, onClick: onClick }), node));
};
Form.Item = Item;
const Header = (props, ref) => {
    const { children, ...rest } = props;
    return (React.createElement("div", Object.assign({}, rest, { ref: ref }),
        React.createElement(OriginalForm.Header, { children: children })));
};
Form.Header = forwardRef(Header);
export default Form;
